import Guid from "_shared/guids/guid";
import Team from "marketplace/teams/team";

/**
 * The one marketplace team a vendor's new draft takes as its vendor team, or undefined when there
 * is not exactly one (#6468).
 *
 * The rule is the server's `NativeMarketplaceService.FindSoleVisibleTeamIdAsync`, which seated the
 * team on a draft that answered a proposal request: of the teams the vendor leads or belongs to,
 * those that are visible and led from the vendor's own legal entity. With none, or with several, the
 * draft keeps its creator-led team, because the page cannot know which team the vendor means.
 */
export function soleVendorMarketplaceTeam(
  teams: readonly Team[] | undefined,
  vendorLegalEntityId: Guid,
): Team | undefined {
  const candidates = (teams ?? []).filter(
    (team) => team.isVisible && team.leader.legalEntityId.isEqualTo(vendorLegalEntityId),
  );
  const distinct = candidates.filter(
    (team, index) => candidates.findIndex((other) => other.id.isEqualTo(team.id)) === index,
  );
  if (distinct.length !== 1) return undefined;
  return distinct[0];
}
